import { render } from "./product-slider-model.vue?vue&type=template&id=506d7c8e"
import script from "./product-slider-model.vue?vue&type=script&lang=js"
export * from "./product-slider-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__